<template>
	<div class="container-fluid h-100 my-2">
		<div class="row justify-content-center align-items-center h-100">
			<div class="col-auto licence_choice">
				<router-link :to="{ name: 'Home' }" class="d-block mb-3"><font-awesome-icon class="mr-1" :icon="['fal', 'arrow-left']"/> {{ $t('global.retour') }}</router-link>
				<div class="box" id="login">

					<div class="text-center"><groomy-logo /></div>

					<div class="text-center mt-4 mb-5">
						<h2 class="mt-0 mb-1">{{ $t('compte.switch_licence.select_licence') }}</h2>
						<i>{{ $t('compte.switch_licence.body') }}</i>
					</div>

					<ul>
						<li v-for="(tiers, index) in filtredTiers" 
							:key="'tiers_'+index"
							@click="chooseTiers(tiers)"
							class="tiers_choice_card d-flex align-items-center"
							:class="{ disabled: !tiers.is_main && is_unvalid }"
						>
							<span>
								<b>{{ tiers.label }}</b>
								<br/>
							</span> 
							<font-awesome-icon class="ml-auto" :icon="['fal', 'angle-right']"/>
						</li>
					</ul>


					<div v-if="verrouLoading">
						<p class="text-center"><font-awesome-icon :icon="['fal', 'spinner']" pulse/><br/>{{ $t('global.chargement') }} </p>
					</div>
					
					<div class="text-center mt-4 mb-5">
						<router-view></router-view>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import UserMixin from '@/mixins/User.js';
	import Navigation from '@/mixins/Navigation.js';

	export default {
		name: "LicenceSwitch",
		mixins: [UserMixin, Navigation],
		data () {
			return {
				tiers_raw: [],
				main_licence: null,
                redirect_post_choice: '',
                is_working: false,
				tiers_filter: '',
				is_unvalid: false, 
			}
		},
		mounted: async function() {
			this.init_component()
		},
		methods: {
            async init_component() {
				this.redirect_post_choice = this.$route.query.redirect
				this.tiers_raw = []
				this.main_licence = this.tiers_raw[0]
            },
            async chooseTiers(licence) {
				const licence_key  = licence.key
				const licence_name = licence.username
				const main_licence_key = this.main_licence.licence_key

				if(!licence.is_main && !this.checkLicencePermissiveSwitch(licence)) {
                    return this.$router.push({ name: 'CheckEmailLS', params: { is_licence_switch: true, temp_licence: main_licence_key }})
				}

				this.is_working = true

				// Juste après le login on est pas log donc on a pas besoin de delog
				if (this.$storage.db) {
					await this.delogUser(true)
				}

                await this.persistUserLicenceKey(licence_key)
                await this.persistUserLicenceName(licence_name)

                // On charge le localstorage de la licence choisie
				this.setUserLoggedIn()

                this.redirectPostLogin(this.redirect_post_choice)
                this.is_working = false
			},
			checkLicencePermissiveSwitch(licence) {
				const valid_mail = this.getConfig("valid_mail")

				// Si le switch de licence se fait sur une licence autre que la principale, on regarde si l'email a été validé
				if(!licence.is_main && !valid_mail) {
					this.is_unvalid = true
					return false
				} 
				return true
			}
		},
		computed: {
            tiers() {
            	if(this.tiers_raw.length == 0) return []

                let temp = []

                this.tiers_raw.forEach(tiers => {
					temp.push({
                        tiers_rs: tiers.tiers_rs,
                    })
                })

                return temp
			},
            filtredTiers() {
                if(!this.tiers_filter) {
                    return this.tiers
                }
                return this.tiers.filter(licence => licence.label.toLowerCase().includes(this.tiers_filter.toLowerCase())) 
            },
			verrouLoading() {
                return this.is_working
			}
		}
	}
</script>
